import { HostBinding, Component, OnInit } from '@angular/core';

import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { DocumentosService } from 'app/shared/documentos/documentos.service';

import { AgrupadorDocumentos, Documento } from 'models/documento';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-cpa',
  templateUrl: './cpa.component.html',
  styleUrls: ['./cpa.component.scss'],
  animations: [routerTransition],
})
export class CpaComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';
  environment = environment;
  docsLoading = true;
  resultadosLoading = true;
  resultadosAutoavaliacaoLoading = true;
  documentos: Documento[] = [];
  resultados: Documento[] = [];
  regulamentos: any = [];
  resultadosAutoavaliacao: Documento[] = [];

  constructor(
    private documentosService: DocumentosService,
  ) {
  }

  ngOnInit() {
    // carregando docs e resultados
    this.documentosService.queryDocumentosCPA()
      .then((groups: AgrupadorDocumentos[]) => {
        if (groups && groups.length > 0) {
          this.documentos = groups[0].documentos;
        }
        this.docsLoading = false;
      });

    this.documentosService.queryResultadosCPA()
      .then((groups: AgrupadorDocumentos[]) => {
        if (groups && groups.length > 0) {
          this.resultados = groups[0].documentos;
        }
        this.resultadosLoading = false;
      });

    this.documentosService.queryResultadosAutoavaliacaoCPA()
      .then((groups: AgrupadorDocumentos[]) => {
        if (groups && groups.length > 0) {
          this.resultadosAutoavaliacao = groups[0].documentos;
        }
        this.resultadosAutoavaliacaoLoading = false;
      });


    this.documentosService.queryRegulamentosCPA()
    .then(result =>{
      this.regulamentos = result[0].documentos;
    });

  }
}
